var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.333 2H9.33301V3.5H15.333V2ZM3.33301 5V6.5H4.83301V21.5C4.83301 22.3284 5.50458 23 6.33301 23H18.333C19.1614 23 19.833 22.3284 19.833 21.5V6.5H21.333V5H3.33301ZM6.33301 21.5V6.5H18.333V21.5H6.33301ZM9.33301 9.5H10.833V18.5H9.33301V9.5ZM15.333 9.5H13.833V18.5H15.333V9.5Z",
    fill: "#E20074"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c387a38b6af74285fc6bc7a4c8b416c8.svg";
export { ForwardRef as ReactComponent };